import { render, staticRenderFns } from "./RsiRelation.vue?vue&type=template&id=282b3f21&"
import script from "./RsiRelation.vue?vue&type=script&lang=js&"
export * from "./RsiRelation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports